var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "recycle-bin d-flex flex-column"
  }, [_c('h1', {
    staticClass: "page-title recycle-toolbar-layer"
  }, [_vm._v("Recycle Bin")]), _c('div', {
    staticClass: "d-flex flex-wrap align-center recycle-toolbar recycle-toolbar-layer"
  }, [_c('v-btn', {
    staticClass: "recycle-toolbar-button",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'SelectSession'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Sessions ")], 1), _c('v-btn', {
    staticClass: "recycle-toolbar-button",
    attrs: {
      "color": "grey darken-4",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.empty_bin_dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete-sweep")]), _vm._v(" Empty Recycle Bin ")], 1)], 1), _c('v-row', {
    staticClass: "recycle-content"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-data-table', {
    staticClass: "sessions-table recycle-sessions-table flex-grow-1",
    attrs: {
      "headers": _vm.displayHeaders,
      "items": _vm.trashed_sessions,
      "options": _vm.session_options,
      "loading": _vm.session_loading,
      "server-items-length": _vm.session_total,
      "mobile-breakpoint": 0,
      "dense": _vm.$vuetify.breakpoint.smAndDown,
      "footer-props": {
        showFirstLastPage: false,
        disableItemsPerPage: true,
        itemsPerPageOptions: [40]
      },
      "fixed-header": "",
      "height": _vm.sessionsTableHeight,
      "single-select": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.session_options = $event;
      },
      "item-selected": _vm.onSelect,
      "click:row": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('div', {
          staticClass: "table-empty-state"
        }, [_c('v-icon', {
          staticClass: "mb-3",
          attrs: {
            "size": "48",
            "color": "grey"
          }
        }, [_vm._v("mdi-delete-outline")]), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v("Recycle bin is empty")]), _c('p', {
          staticClass: "text-caption mb-0 mt-1"
        }, [_vm._v("Trashed sessions will appear here")])], 1)];
      },
      proxy: true
    }, {
      key: "item.controls",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "session-controls-cell"
        }, [_vm.$vuetify.breakpoint.smAndDown && item.trashed ? [_c('v-btn', {
          staticClass: "menu-button",
          attrs: {
            "icon": "",
            "dark": "",
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openSessionMenuSheet(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)] : item.trashed ? _c('v-menu', {
          attrs: {
            "offset-y": "",
            "right": "",
            "close-on-content-click": "",
            "content-class": "recycle-session-context-menu"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "menu-button",
                attrs: {
                  "icon": "",
                  "dark": "",
                  "small": ""
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                  }
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
            }
          }], null, true),
          model: {
            value: item.isMenuOpen,
            callback: function ($$v) {
              _vm.$set(item, "isMenuOpen", $$v);
            },
            expression: "item.isMenuOpen"
          }
        }, [_c('v-list', [_c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeSessionMenuAndRestore(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Restore")])], 1), _c('v-list-item', {
          attrs: {
            "link": ""
          },
          on: {
            "click": function ($event) {
              return _vm.closeSessionMenuAndPermanentDelete(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Delete permanently")])], 1)], 1)], 1) : _vm._e()], 2)];
      }
    }, {
      key: "item.id",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "session-id-cell",
          attrs: {
            "title": item.id
          }
        }, [_c('span', {
          staticClass: "session-id-preview"
        }, [_vm._v(_vm._s(_vm.getSessionIdPreview(item.id)))]), _c('v-btn', {
          staticClass: "copy-session-id-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Copy session ID"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.copySessionId(item.id);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy")])], 1)], 1)];
      }
    }, {
      key: "item.sessionName",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "session-name-text"
        }, [_vm._v(_vm._s(item.sessionName || 'Untitled'))])];
      }
    }, {
      key: "item.created_at",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(item.created_at)))])];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_vm.selected ? _c('v-simple-table', {
    staticClass: "recycle-trials-table",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Trial name ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Status ")])])]), _c('tbody', [_vm.trial_loading ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('div', {
          staticClass: "recycle-trials-loading"
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "size": "28",
            "width": "3",
            "color": "grey lighten-1"
          }
        }), _c('span', [_vm._v("Loading trials...")])], 1)])]) : _vm.trialsMapped.length === 0 ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('div', {
          staticClass: "recycle-trials-empty"
        }, [_vm._v(" No trials found ")])])]) : _vm._l(_vm.trialsMapped, function (trial) {
          return _c('tr', {
            key: trial.id
          }, [_c('td', [_c('div', {
            staticClass: "float-right"
          }, [_vm.$vuetify.breakpoint.smAndDown && trial.trashed ? [_c('v-btn', {
            attrs: {
              "icon": "",
              "dark": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openTrialMenuSheet(trial);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)] : trial.trashed ? _c('v-menu', {
            attrs: {
              "offset-y": "",
              "right": "",
              "close-on-content-click": "",
              "content-class": "recycle-trial-context-menu"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref6) {
                var on = _ref6.on,
                  attrs = _ref6.attrs;
                return [_c('v-btn', _vm._g(_vm._b({
                  attrs: {
                    "icon": "",
                    "dark": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
              }
            }], null, true),
            model: {
              value: trial.isMenuOpen,
              callback: function ($$v) {
                _vm.$set(trial, "isMenuOpen", $$v);
              },
              expression: "trial.isMenuOpen"
            }
          }, [_c('v-list', [_c('v-list-item', {
            attrs: {
              "link": ""
            },
            on: {
              "click": function ($event) {
                return _vm.closeTrialMenuAndRestore(trial);
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Restore")])], 1), _c('v-list-item', {
            attrs: {
              "link": ""
            },
            on: {
              "click": function ($event) {
                return _vm.closeTrialMenuAndPermanentDelete(trial);
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Delete permanently")])], 1)], 1)], 1) : _vm._e()], 2), _c('div', {
            staticClass: "mt-2"
          }, [_vm._v(_vm._s(trial.name))])]), _c('td', [_vm._v(_vm._s(trial.status))])]);
        })], 2)];
      },
      proxy: true
    }], null, false, 275306076)
  }) : _vm._e()], 1)], 1), _c('v-bottom-sheet', {
    attrs: {
      "content-class": "bottom-sheet-rounded"
    },
    on: {
      "input": function (val) {
        return !val && (_vm.selectedSessionForMenu = null);
      }
    },
    model: {
      value: _vm.showSessionMenuSheet,
      callback: function ($$v) {
        _vm.showSessionMenuSheet = $$v;
      },
      expression: "showSessionMenuSheet"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center recycle-menu-sheet"
  }, [_vm.selectedSessionForMenu ? _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRestoreSession(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-restore")]), _c('span', [_vm._v("Restore")])], 1)])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndPermanentDeleteSession(_vm.selectedSessionForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-forever")]), _c('span', [_vm._v("Delete permanently")])], 1)])], 1)], 1) : _vm._e()], 1)], 1), _c('v-bottom-sheet', {
    attrs: {
      "content-class": "bottom-sheet-rounded"
    },
    on: {
      "input": function (val) {
        return !val && (_vm.selectedTrialForMenu = null);
      }
    },
    model: {
      value: _vm.showTrialMenuSheet,
      callback: function ($$v) {
        _vm.showTrialMenuSheet = $$v;
      },
      expression: "showTrialMenuSheet"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center recycle-menu-sheet"
  }, [_vm.selectedTrialForMenu ? _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRestoreTrial(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-restore")]), _c('span', [_vm._v("Restore")])], 1)])], 1), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndPermanentDeleteTrial(_vm.selectedTrialForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-forever")]), _c('span', [_vm._v("Delete permanently")])], 1)])], 1)], 1) : _vm._e()], 1)], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSessionHideMenu,
      expression: "clickOutsideDialogSessionHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.restore_session_dialog,
      callback: function ($$v) {
        _vm.restore_session_dialog = $$v;
      },
      expression: "restore_session_dialog"
    }
  }, [_vm.selectedSessionForRestore ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-undo-variant")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to restore session "), _c('code', [_vm._v(_vm._s(_vm.selectedSessionForRestore.id))]), _vm._v("?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_session_dialog = false;
        _vm.selectedSessionForRestore = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_session_dialog = false;
        _vm.restoreSession(_vm.selectedSessionForRestore.id);
        _vm.selectedSessionForRestore = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSessionHideMenu,
      expression: "clickOutsideDialogSessionHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.remove_permanently_session_dialog,
      callback: function ($$v) {
        _vm.remove_permanently_session_dialog = $$v;
      },
      expression: "remove_permanently_session_dialog"
    }
  }, [_vm.selectedSessionForPermanentDelete ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to "), _c('strong', [_vm._v("permanently")]), _vm._v(" remove session "), _c('code', [_vm._v(_vm._s(_vm.selectedSessionForPermanentDelete.id))]), _vm._v("?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_session_dialog = false;
        _vm.selectedSessionForPermanentDelete = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_session_dialog = false;
        _vm.permanentRemoveSession(_vm.selectedSessionForPermanentDelete.id);
        _vm.selectedSessionForPermanentDelete = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogTrialHideMenu,
      expression: "clickOutsideDialogTrialHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.restore_trial_dialog,
      callback: function ($$v) {
        _vm.restore_trial_dialog = $$v;
      },
      expression: "restore_trial_dialog"
    }
  }, [_vm.selectedTrialForRestore ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-undo-variant")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to restore trial " + _vm._s(_vm.selectedTrialForRestore.name) + "?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_trial_dialog = false;
        _vm.selectedTrialForRestore = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_trial_dialog = false;
        _vm.restoreTrial(_vm.selectedTrialForRestore);
        _vm.selectedTrialForRestore = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogTrialHideMenu,
      expression: "clickOutsideDialogTrialHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.remove_permanently_trial_dialog,
      callback: function ($$v) {
        _vm.remove_permanently_trial_dialog = $$v;
      },
      expression: "remove_permanently_trial_dialog"
    }
  }, [_vm.selectedTrialForPermanentDelete ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to "), _c('strong', [_vm._v("permanently")]), _vm._v(" remove trial " + _vm._s(_vm.selectedTrialForPermanentDelete.name) + "?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_trial_dialog = false;
        _vm.selectedTrialForPermanentDelete = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_trial_dialog = false;
        _vm.permanentRemoveTrial(_vm.selectedTrialForPermanentDelete);
        _vm.selectedTrialForPermanentDelete = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.empty_bin_dialog,
      callback: function ($$v) {
        _vm.empty_bin_dialog = $$v;
      },
      expression: "empty_bin_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v(" Do you want to "), _c('strong', [_vm._v("permanently")]), _vm._v(" empty the Recycle Bin? ")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.empty_bin_dialog = false;
      }
    }
  }, [_vm._v(" No ")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.empty_bin_dialog = false;
        _vm.emptyBin();
      }
    }
  }, [_vm._v(" Yes ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }